export const osdetect = {
    initCompleted: false,
    isWebkit: false,
    isIphone: false,
    isAndroid: false,
    isAndroidPhone: false,
    isWindowsTablet: false,
    isAndroidTablet: false,
    engineWebKit: 'webkit',
    deviceAndroid: 'android',
    deviceHtcFlyer: 'htc_flyer',
    deviceSamsungTab3: 'sm-t210r',
    deviceIphone: 'iphone',
    deviceIpod: 'ipod',
    deviceIpad: 'ipad',
    deviceWindowsTablet: 'trident',
    mobile: 'mobile',
    tablet: 'tablet',
    uagent: '',
    __initDeviceScan__() {
        this.initCompleted = false;
        if (navigator && navigator.userAgent) {
            this.uagent = navigator.userAgent.toLowerCase();
        }

        this.isWebkit = this.detectWebkit();
        this.isAndroid = this.detectAndroid();
        this.isAndroidPhone = this.detectAndroidPhone();
        this.isIphone = this.detectIphone();
        this.isWindowsTablet = this.detectWindowsTablet();
        this.isAndroidTablet = this.detectAndroidTablet();

        this.initCompleted = true;
    },
    detectAndroid() {
        if (this.initCompleted || this.isAndroid) {
            return this.isAndroid;
        }
        if (this.uagent.search(this.deviceAndroid) > -1) {
            return true;
        }
        if (this.uagent.search(this.deviceHtcFlyer) > -1) {
            return true;
        } else {
            return false;
        }
    },
    detectAndroidPhone() {
        if (this.initCompleted || this.isAndroidPhone) {
            return this.isAndroidPhone;
        }
        if (this.detectAndroid() && (this.uagent.search(this.mobile) > -1)) {
            return true;
        }
        if (this.uagent.search(this.deviceHtcFlyer) > -1) {
            return true;
        } else {
            return false;
        }
    },
    detectAndroidTablet() {
        if (!this.detectAndroid()) {
            return false;
        }
        if (this.uagent.search(this.deviceHtcFlyer) > -1) {
            return false;
        }
        if (this.uagent.search(this.mobile) > -1) {
            return false;
        } else {
            return true;
        }
    },
    detectAndroidWebKit() {
        if (this.detectAndroid() && this.detectWebkit()) {
            return true;
        } else {
            return false;
        }
    },
    detectIphone() {
        if (this.initCompleted || this.isIphone) {
            return this.isIphone;
        }
        if (this.uagent.search(this.deviceIphone) > -1) {
            if (this.detectIpad() || this.detectIpod()) {
                return false;
            } else {
                return true;
            }
        } else {
            return false;
        }
    },
    detectIpod() {
        if (this.uagent.search(this.deviceIpod) > -1) {
            return true;
        } else {
            return false;
        }
    },
    detectIphoneOrIpod() {
        if (this.detectIphone() || this.detectIpod()) {
            return true;
        } else {
            return false;
        }
    },
    detectIpad() {
        if (this.uagent.search(this.deviceIpad) > -1 && this.detectWebkit()) {
            return true;
        } else {
            return false;
        }
    },
    detectIos() {
        if (this.detectIphoneOrIpod() || this.detectIpad()) {
            return true;
        } else {
            return false;
        }
    },
    detectWebkit() {
        if (this.initCompleted || this.isWebkit) {
            return this.isWebkit;
        }
        if (this.uagent.search(this.engineWebKit) > -1) {
            return true;
        } else {
            return false;
        }
    },
    detectSmartPhone() {
        if (this.detectAndroidPhone() || this.detectIphoneOrIpod()) {
            return true;
        }
        // BB z10 desktop mode
        if (this.detectWebkit() && screen.width == 343 && screen.height == 571) {
            return true;
        }
        return false;
    },
    detectWindowsTablet() {
        if (this.initCompleted || this.isWindowsTablet) {
            return this.isWindowsTablet;
        }
        if (this.uagent.search(this.deviceWindowsTablet) > -1 && this.uagent.search(this.tablet) > -1) {
            return true;
        }
        return false;
    },
    detectTablet() {
        return (this.detectIpad()
            || this.detectAndroidTablet()
            || (this.uagent.search(this.tablet) > -1) && (('ontouchstart' in window) || (navigator.msMaxTouchPoints > 0)));
    },
    detectAndroidPhoneVersion() {
        const version = this.uagent.match(/Android|android\s+([\d\.]+)/);
        if (version) {
            if (this.isAndroidPhone) {
                return version[1];
            }
            if (this.detectAndroid() && (this.uagent.search(this.mobile) > -1)) {
                return version[1];
            }
            if (this.uagent.search(this.deviceHtcFlyer) > -1) {
                return version[1];
            }
        }
    },
    detectAndroidTabletVersion() {
        const version = this.uagent.match(/Android|android\s+([\d\.]+)/);
        if (version) {
            if (this.isAndroidTablet) {
                return version[1];
            }
            if (this.detectAndroid() && (this.uagent.search(this.tablet) > -1)) {
                return version[1];
            }
        }
    },
    detectSamsungTab3Tablet() {
        if (this.uagent.toLowerCase().indexOf(this.deviceSamsungTab3) > -1) {
            return true;
        }
        return false;
    },
    detactMobileDevice() {
        return this.detectSmartPhone() || this.detectTablet();
    },
};
osdetect.__initDeviceScan__();
